import { render, staticRenderFns } from "./HeroContainer.vue?vue&type=template&id=5bf156da&scoped=true"
import script from "./HeroContainer.vue?vue&type=script&lang=ts"
export * from "./HeroContainer.vue?vue&type=script&lang=ts"
import style0 from "./HeroContainer.vue?vue&type=style&index=0&id=5bf156da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf156da",
  null
  
)

export default component.exports